'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@svs/ui/react/button';
import { usePathname, useSearchParams } from 'next/navigation';
import { TipsenLink } from '../TipsenLink/entry.js';
/**
 * Util component to close a modal, comes with a default style that can be overridden if needed.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @param root0.variant the variant of the button, defaults to primary
 * @returns Button to close the modal
 */
export default function CloseModalButton({ children, variant, ...props }) {
    const searchParams = useSearchParams();
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('modal');
    const processEnvBasePath = process.env['NEXT_PUBLIC_BASE_PATH'] ?? '';
    const currentPathName = usePathname();
    const path = currentPathName.includes(processEnvBasePath)
        ? currentPathName.slice(processEnvBasePath.length)
        : currentPathName;
    return (_jsx(Button, { className: "w-full", asChild: true, variant: variant ?? 'primary', children: _jsx(TipsenLink, { ...props, replace: true, href: {
                pathname: path.startsWith('/') ? path : `/${path}`,
                query: Object.fromEntries(newSearchParams),
            }, children: children }) }));
}
//# sourceMappingURL=CloseModalButton.js.map